import React, { useState } from "react";
import PropTypes from "prop-types";
import { Field, Control } from "rbx";
import Select from "react-select";

const OrderStatusFilter = ({ filters, options }) => {
  const [selected] = useState(
    options.filter(opt => opt.value === filters.StatusRecIdRef)
  );

  return (
    <div>
      <Field>
        <Control>
          <Select
            isMulti
            closeMenuOnSelect={false}
            name="StatusRecIdRef"
            options={options}
            value={selected}
            onChange={() => console.log}
          />
        </Control>
      </Field>
    </div>
  );
};

OrderStatusFilter.propTypes = {
  filters: PropTypes.object,
  options: PropTypes.array
};

export default OrderStatusFilter;
